import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { GetFormResponse } from 'compliance-api';

export const CURRENT_FORM_QUERY_KEY = 'vestra-compliance/form';

export const useFormQuery = (
  id: number,
  options: {
    onSuccess?: (form: GetFormResponse) => void;
    disabled?: boolean;
  },
) => {
  const { onSuccess, disabled } = options;
  return useQuery({
    queryKey: [CURRENT_FORM_QUERY_KEY, id],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.getFormV1FormsIdGet({ id });
      return response.data;
    },
    onSuccess,
    keepPreviousData: true,
    retry: 2,
    enabled: !disabled,
  });
};
